import { Injectable } from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AnalyticsServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    private companyId = global['loginUser'].curCmpnId;

    constructor(private http: Http) {
        this.companyId = global['loginUser'].curCmpnId;
    };

    /**
     * analytics - system
     * Incident Metric Chart
     * Method : Get
     * API No : 15.1
     * url : /api/v1/{cmpnNo}/report/metric/chart?startDt={startDt}&endDt={endDt}&urgency={urgency}&groupBy={groupBy}&trgtNos={trgtNo}&metric={metric}&event={event}
     * **/
    getSystemMetricChart(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/metric/chart${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - system
     * Incident Metirc Table
     * Method : Get
     * API No : 15.2
     * url : /api/v1/{cmpnNo}/report/metric/table?startDt={startDt}&endDt={endDt}&urgency={urgency}&groupBy={groupBy}&event={event}&oidx={oidx}&page={page}&rows={rows}
     * **/
    getSystemMetricTable(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/metric/table${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - system
     * Incident List
     * Method : Get
     * API No : 15.3
     * url : /api/v1/{cmpnNo}/report/incident?startDt={startDt}&endDt={endDt}&page={page}&rows={rows}&oidx={oidx}&urgency={urgency}&groupBy={groupBy}&event={event}&trgtNos={trgtNo}
     * **/
    getSystemIncidentList(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident${queryParam}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - system
     * CSV 다운로드
     * Method : Get
     * API No : 15.4
     * url : /api/v1/{cmpnNo}/report/incident.csv?startDt={startDt}&endDt={endDt}&urgency={urgency}&groupBy={groupBy}&event={event}&trgtNos={trgtNo}
     * **/
    downloadSystemIncidentCSV(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        // location.href = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident.csv${queryParam}`;

        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident.csv${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - notification
     * Notification Data Chart
     * Method : Get
     * API No : 15.5
     * url : /api/v1/{cmpnNo}/report/noti/chart?startDt={startDt}&endDt={endDt}
     * **/
    getNotiDataChart(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/noti/chart${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - notification
     * Notification Data (Chart, Table 공용)
     * Method : Get
     * API No : 15.6
     * url : /api/v1/{cmpnNo}/report/noti/table?startDt={startDt}&endDt={endDt}&groupBy={groupBy}
     * **/
    getNotiDataTable(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/noti/table${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - notification
     * Notification List (상세 화면)
     * Method : Get
     * API No : 15.7
     * url : /api/v1/{cmpnNo}/report/noti?startDt={startDt}&endDt={endDt}&page={page}&rows={rows}&oidx={oidx}
     * **/
    getNotificationList(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/noti${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - notification
     * CSV 다운로드
     * Method : Get
     * API No : 15.8
     * url : /api/v1/{cmpnNo}/report/noti.csv?startDt={startDt}&endDt={endDt}
     * **/
    downloadNotificationCSV(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        // location.href = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident.csv${queryParam}`;

        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/noti.csv${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }


    /**
     * analytics - incident
     * All Incident Data
     * Method : Get
     * API No : 15.9
     * url : /api/v1/{cmpnNo}/report/incident/all?startDt={startDt}&endDt={endDt}
     * **/
    getAllIncidentData(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident/all${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - incident
     * Incident Data By Service Top 10
     * Method : Get
     * API No : 15.10
     * url : /api/v1/{cmpnNo}/report/incident/service?startDt={startDt}&endDt={endDt}
     * **/
    getIncidentDataBySvc(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident/service${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - incident
     * Incident Data By Urgency
     * Method : Get
     * API No : 15.11
     * url : /api/v1/{cmpnNo}/report/incident/urgency?startDt={startDt}&endDt={endDt}
     * **/
    getIncidentDataByUrgency(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident/urgency${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - incident
     * Incident Data By Integration
     * Method : Get
     * API No : 15.12
     * url : /api/v1/{cmpnNo}/report/incident/integration?startDt={startDt}&endDt={endDt}
     * **/
    getIncidentDataByItgr(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident/integration${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - incident
     * Incident Data By Time
     * Method : Get
     * API No : 15.13
     * url : /api/v1/{cmpnNo}/report/incident/time?startDt={startDt}&endDt={endDt}
     * **/
    getIncidentDataByTime(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident/time${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - incident
     * Incident Data Chart
     * Method : Get
     * API No : 15.14
     * url : /api/v1/{cmpnNo}/report/incident/chart?startDt={startDt}&endDt={endDt}&groupBy={groupBy}
     * **/
    getIncidentDataChart(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident/chart${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }

    /**
     * analytics - system
     * Last Updated Date
     * Method : Get
     * API No : 15.15
     * url : /api/v1/{cmpnNo}/report/exetime
     * **/
    getSystemExeTime() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/exetime`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - system
     * Incident Metirc Table CSV 다운로드
     * Method : Get
     * API No : 15.16
     * url : /api/v1/{cmpnNo}/report/metric/table.csv?startDt={startDt}&endDt={endDt}&urgency={urgency}&groupBy={groupBy}&event={event}&oidx={oidx}&page={page}&rows={rows}
     * **/
    downloadSystemMetricTableCSV(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/metric/table.csv${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * analytics - incident
     * Incident Data Chart CSV 다운로드
     * Method : Get
     * API No : 15.17
     * url : /api/v1/{cmpnNo}/report/incident/chart.csv?startDt={startDt}&endDt={endDt}&groupBy={groupBy}
     * **/
    getIncidentDataChartCSV(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/report/incident/chart.csv${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/analytics.services.ts